import { fork } from 'redux-saga/effects';
import { authorizationSaga } from '../pages/login/auth.saga';
import { mainSaga } from '../main/main.saga';
import { settingsMainSaga } from '../pages/settings/settingsMain.saga';
import { clientsSaga } from '../pages/clients/clients.saga';
import { partnersSaga } from '../pages/partners/partners.saga';
import { templatesMainSaga } from '../pages/templates/templatesMain.saga';
import { resultsMainSaga } from '../pages/results/resultsMain.saga';

export default function* root() {
	yield fork(authorizationSaga);
	yield fork(mainSaga);

	//
	yield fork(settingsMainSaga);
	yield fork(partnersSaga);
	yield fork(clientsSaga);
	yield fork(templatesMainSaga);
	yield fork(resultsMainSaga);
}
